export default __webpack_public_path__ + "static/media/smallcheck.8de73068.svg";